/*jslint browser: true */
/*global window */

module.exports = function ()
{
	'use strict';
	const self = this || {};
	const winAlias = window;
	const docAlias = winAlias.document;
	const navAlias = winAlias.navigator;

	let endpoint = 'https://lec.npgcdn.net/';

	self.setEndpoint = function(ep)
	{
		endpoint = ep;
	};

	self.supportsBeacon = function()
	{
		return 'object' == typeof navAlias &&
			'function' == typeof navAlias.sendBeacon &&
			'function' == typeof Blob;
	};

	self.send = function(data, callback, method)
	{
		method = method || 'beacon';

		if (method == 'pixel')
			return self.sendPixel(data, callback);
		else if (method == 'beacon') {
			var result = self.sendBeacon(data, callback);

			if (result)
				return true;
		}

		self.sendAjax(data, callback);
	};

	self.sendPixel = function(data, callback)
	{
		const url = endpoint + "px.gif?data=" + encodeURIComponent(JSON.stringify(data));

		let img = new Image(1, 1);
		img.onload = function ()
		{
			if (typeof callback == 'function') {
				callback({data: data, success: true});
			}
		};

		img.onerror = function ()
		{
			if (typeof callback == 'function') {
				callback({data: data, success: false});
			}
		};

		img.src = url;
	};

	self.sendBeacon = function (data, callback)
	{
		if (!self.supportsBeacon())
			return false;

		const headers = {type: 'application/json'};
		const url = endpoint + 'collector';

		const blob = new Blob([JSON.stringify(data)], headers);

		let success = false;

		try {
			success = navAlias.sendBeacon(url, blob);
		} catch (e) {
			return false;
		}

		if (success && typeof callback == 'function')
		{
			callback({data: data, success: true});
		}

		return success;
	};

	self.sendAjax = function (data, callback)
	{
		setTimeout(function () {
			try {
				let xhr = winAlias.XMLHttpRequest ? new winAlias.XMLHttpRequest() : (winAlias.ActiveXObject ? new ActiveXObject('Microsoft.XMLHTTP') : null);
				const url = endpoint + 'collector';

				xhr.open('POST', url, true);

				xhr.onreadystatechange = function () {
					if (this.readyState === 4)
					{
						let success = (this.status >= 200 && this.status < 300);

						if (typeof callback === "function")
						{
							callback({data: data, success: success});
						}
					}
				};

				xhr.setRequestHeader('Content-Type', 'application/json');
				xhr.withCredentials = false;
				xhr.send(JSON.stringify(data));
			} catch (e) {
				return self.sendPixel(data, callback);
			}
		});
	};

	return self;
}();
